site.stickyHead = {
	init:function() {
		window.addEventListener('scroll', function(e){
			var distanceY = window.pageYOffset || document.documentElement.scrollTop,
				shrinkOn = 20;
			if (distanceY > shrinkOn) {
				$('body').addClass('stickyHead');
			} else {
				$('body').removeClass('stickyHead');
			}
		});
	}
};

site.inits.push('site.stickyHead.init()');
